const nad = new Intl.NumberFormat('en-NA', {
  style: 'currency',
  currency: 'NAD',
  minimumFractionDigits: 2,
});

export function formatNadFromCents(cents: number): string {
  return nad.format(cents / 100);
}

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('en-NA', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}
